'use client'

import { ArrowLeftIcon, Button } from '@nwwp/ui-shadcn'

export const BackButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    onClick={onClick}
    aria-label="Go back"
    className="text-white hover:text-white"
  >
    <ArrowLeftIcon
      aria-hidden
      className="-translate-y-1"
      style={{ width: 'clamp(24px, 5vw, 36px)', height: 'clamp(24px, 5vw, 36px)' }}
    />
  </Button>
)
